export default __webpack_public_path__ + "static/media/fecha-filtro-avisos-mantenimiento.f4514c6d.svg";